var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDbarrow(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 74,
    height: 80,
    viewBox: "0 0 74 80",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M0.855686 33.8675L31.4264 1.7086C33.5439 0.120513 38.8905 -1.7852 43.3371 3.2967L72.7168 33.8675C77.5119 38.9082 67.1893 50.0249 61.2031 44.1901L40.558 22.3539C38.2065 19.8511 36.2214 19.8511 33.8086 22.3539L11.5753 44.9842C7.63622 48.8338 -3.08391 37.7172 0.855686 33.8675ZM43.773 39.0886C39.8494 35.0706 33.3873 35.0706 29.4638 39.0886L6.10085 63.0136C-0.0835128 69.3467 4.4036 80.0001 13.2555 80.0001H59.9813C68.8331 80.0001 73.3203 69.3467 67.1359 63.0136L43.773 39.0886Z",
    fill: "#D9D9D9"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDbarrow);
export default __webpack_public_path__ + "static/media/dbarrow.5d9a4a0bf4540c19aef3949bee810a9f.svg";
export { ForwardRef as ReactComponent };